import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-hosting',
  templateUrl: './hosting.component.html',
  styleUrls: ['./hosting.component.css']
})
export class HostingComponent implements OnInit {
  public active: string;

  constructor() {
    this.active = '24/7';
  }

  ngOnInit() {
  }

  public activate = (value: string): void => {
    this.active = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/hosting/hosting.component.ts